import { DeclareMethod } from '/imports/methods';

export const handleGoogleOauth2Code = DeclareMethod<{ code: string, referralCode?: string }, any>('handleGoogleOauth2Code');
export const handleDiscordOauth2Code = DeclareMethod<{ code: string, referralCode?: string }, any>('handleDiscordOauth2Code');